import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/share-square': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M561.9 158.1c18.8 18.7 18.8 49.1 0 67.9l-144 144c-30 30-81.9 9.1-81.9-33.9v-53.8c-101.3 7.8-99.6 31.6-84.1 78.8 14.2 43.1-33.5 79.2-71 55.7-51.7-32.3-84.9-83.1-84.9-144.8 0-39.3 12.2-72.7 36.3-99.3 19.8-21.8 47.7-38.5 82.9-49.4 36.7-11.4 78.3-16.1 120.8-18v-57.2c0-42.9 51.9-64 81.9-33.9zM384 336l144-144-144-144v104.1c-110.9 0.9-240 10.5-240 119.9 0 52.1 32.8 85.6 62.3 104.1-39.8-120.7 49-141.9 177.7-143.8v103.8zM408.7 420.5c6.1-1.8 15.5-5.9 21-9.3 8-5 18.3 0.8 18.3 10.2v42.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h132c6.6 0 12 5.4 12 12v4.5c0 4.9-3 9.4-7.6 11.2-13.7 5.3-26.4 11.5-38 18.6-1.6 1-4.4 1.8-6.3 1.8h-86.1c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6v-26c0-5.4 3.6-10.1 8.7-11.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/share-square.js
// module id = 1814
// module chunks = 0